<!-- header -->
<template>
  <div>
    <div class="logo-wrap">
      <div class="content">
        <router-link to="/"><img src="./../assets/logo.png" alt=""></router-link>
        <div class="search-wrap">
          <input type="text">
          <button class="search-btn">搜索</button>
          <button class="publish-btn" @click="publish">免费发布信息</button>
          <router-link to="/aboutUs"><span class="us">关于我们</span></router-link>
          <router-link to="/connectUs"><span class="us">联系我们</span></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    publish: function() {
      this.$router.push({
        path: "/publish"
      });
    }
  }
};
</script>
<style scoped>
.logo-wrap {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  background: #fff;
}
.content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.logo-wrap .content img {
  height: 75px;
}
.logo-wrap .content .search-wrap {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 48px;
  margin-left: 50px;
}
.logo-wrap .content .search-wrap input {
  width: 280px;
  height: 100%;
  border: 2px solid #00a0e9;
  box-sizing: border-box;
}
.logo-wrap .content .search-wrap .search-btn,
.publish-btn {
  height: 100%;
  font-size: 18px;
  background: #00a0e9;
  color: #fff;
  border: none;
}
.logo-wrap .content .search-wrap .search-btn {
  width: 121px;
  cursor: pointer;
}
.logo-wrap .content .search-wrap .publish-btn {
  width: 200px;
  margin-left: 32px;
  cursor: pointer;
}
.logo-wrap .content .search-wrap .us {
  font-size: 18px;
  color: #00a0e9;
  margin-left: 39px;
}
</style>


// WEBPACK FOOTER //
// src/components/LogoHeader.vue